export enum FolderTypeApi {
    PARENT = "ueberordner",
    FORMULAR = "formular_ordner",
    LEISTUNG = "leistungsordner",
    LEISTUNG_OHNE_PREISE = "leistungsordner_ohne_preise",
    IMAGE = "bilder_ordner",
    FREE = "freier_ordner",
    DOCUMENTATION = "doku_ordner"
}
